<template>
  <v-layout row justify-center>
    <v-dialog :value="dialog" @input="$emit('onCancel')" width="500px" flat>
      <v-form ref="payoutForm">
        <v-card flat>
          <v-card-title>
            <h3>{{ type == DEFINES.MONETIZATION.PAYOUT.DISPUTE_FROM_CLIENT ? $t('screener.dispute.title'):$t('screener.adjustment.title') }}</h3>
          </v-card-title>
          <v-divider></v-divider>
          <v-layout row wrap class="pa-3">
            <v-flex xs12>
              <v-text-field
                :label="
                  type == DEFINES.MONETIZATION.PAYOUT.DISPUTE_FROM_CLIENT
                    ? 'Dispute Penalty/Cost'
                    : 'Adjustment Amount'
                "
                :rules="
                  type == DEFINES.MONETIZATION.PAYOUT.DISPUTE_FROM_CLIENT
                    ? [rules.required, rules.floating_number]
                    : [rules.required]
                "
                v-model.number="localPayoutAmount"
                :prefix="getCurrencySymbol(currency)"
                color="primary"
              >
              </v-text-field>
              <v-alert
                :value="showNegativeAmountMessage"
                border="right"
                color="blue-grey"

              >
                A negative value is in favor of the client (Org), meaning it’s added to the client unpaid revenue
              </v-alert>
              <v-alert
                :value="showPositiveAmountMessage"
                border="right"
                color="blue-grey"
                >
                A positive value is in favor of MEW, meaning it’s deducted from the client unpaid revenue
              </v-alert>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Client Note"
                :rules="[rules.required]"
                v-model="localClientNote"
                color="primary"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Admin Note"
                :rules="[rules.required]"
                v-model="localAdminNote"
                color="primary"
              >
              </v-text-field>
            </v-flex>
          </v-layout>

          <v-card-actions class="pa-3">
             <v-btn v-if="payout_amount" dark @click.stop="$emit('onRemoval')" color="warning">{{
              $t('rms.button.remove')
            }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn dark @click.stop="$emit('onCancel')" color="grey">{{
              $t('rms.button.cancel')
            }}</v-btn>
            <v-btn dark @click.stop="confirmPayout" color="primary">{{
              $t('rms.button.add_or_edit')
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import {currencySymbol} from '@/mixins/monetization';
import rules from '@/validation';
import DEFINES from '@/defines';

export default {
  data() {
    return {
      rules,
      showPositiveAmountMessage : false,
      showNegativeAmountMessage : false
    };
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    client_note: {type: String, default: null},
    payout_amount: {default: null},
    admin_note: {type: String, default: null},
    currency: {type: String, default: null},
    type: {type:Number, default: null},
  },
  mixins: [currencySymbol],
  computed: {
    localPayoutAmount: {
      get: function() {
        return this.payout_amount;
      },
      set: function(value) {
        this.$emit('update:payout_amount', value);
      },
    },

    localClientNote: {
      get: function() {
        return this.client_note;
      },
      set: function(value) {
        this.$emit('update:client_note', value);
      },
    },

    localAdminNote: {
      get: function() {
        return this.admin_note;
      },
      set: function(value) {
        this.$emit('update:admin_note', value);
      },
    },
  },
  watch:{
    localPayoutAmount(){
      if (this.localPayoutAmount > 0) {
        this.showPositiveAmountMessage = true;
        this.showNegativeAmountMessage = false;
      }

      if (this.localPayoutAmount < 0 && this.type == DEFINES.MONETIZATION.PAYOUT.ADJUSTMENT) {
        this.showNegativeAmountMessage = true;
        this.showPositiveAmountMessage = false;
      }

      if(!this.localPayoutAmount){
        this.showNegativeAmountMessage = false;
        this.showPositiveAmountMessage = false;
      }
    }
  },
  methods: {
    confirmPayout() {
      if (!this.$refs.payoutForm.validate()) {
        return false;
      }

      this.$emit('onPayout');
    },
  },
};
</script>

<style></style>
